/*
    View Switcher
    Version:1.0
    Author:Rory Saxby & Jake Upshall

    EXAMPLE:

    *** Initialise ***

    var exampleViewSwitcher = new logicjs.viewSwitcher({
        viewToggleClass:'view-switcher-toggle',
        views:'view-switcher-region',
        viewToggleAttr: 'data-target-view-id',
        viewHiddenClass: 't-visually-hidden
    });

    *** Markup ***
    <div id="ExampleView1" class="view-switcher-region">
        <button type="button" class="view-switcher-toggle" data-target-view-id="ExampleView2">Open Example View 2</button>
    </div>
    <div id="ExampleView2" class="view-switcher-region t-visually-hidden">
        <button type="button" class="view-switcher-toggle" data-target-view-id="ExampleView1">Open Example View 1</button>
    </div>

 */

if (typeof logicjs === "undefined") var logicjs = {};

logicjs.viewSwitcher = function (opts) {

    this.viewToggleClass = opts.viewToggleClass;
    this.viewToggles = document.getElementsByClassName(opts.viewToggleClass) || null;
    this.views = document.getElementsByClassName(opts.views) || null;
    this.viewToggleAttr = opts.viewToggleAttr || "data-target-view-id";
    this.viewHiddenClass = opts.viewHiddenClass || 't-visually-hidden';
    this.toggleViews = opts.toggleViews || false;

    this.onActivateView = opts.onActivateView || null;

    this.init();
};

logicjs.viewSwitcher.prototype.bindCtrls = function () {
    var _ = this;
    for (var i = 0; i < this.viewToggles.length; i++) {
        this.viewToggles[i].addEventListener("mouseup", this.handleClick.bind(
            {
                root: this,
                toggle: this.viewToggles[i]
            }
        ));
    }
};

logicjs.viewSwitcher.prototype.handleClick = function (e) {
    if (this.root.toggleViews) { this.root.hideAll(); }
    this.root.toggleViewState(this.toggle);
};

logicjs.viewSwitcher.prototype.hideAll = function () {
    if (this.views) {
        for (var i = 0; i < this.views.length; i++) {
            this.views[i].classList.add(this.viewHiddenClass);
        }
    }
};

logicjs.viewSwitcher.prototype.toggleViewState = function (target) {
    var view = document.getElementById(target.attributes.getNamedItem(this.viewToggleAttr).value);
    view.classList.toggle(this.viewHiddenClass);
    if (this.onActivateView) this.onActivateView(view);
};

logicjs.viewSwitcher.prototype.init = function () {
    this.bindCtrls();
};